<script>
  import { blurOnClick } from '../../../../../../js/blurOnClick';
  import { trackLinkClick } from '../../../../../../js/trackLinkClick';

  export let id;
  export let title;
  export let url;
</script>

<a {id} href={url} class="Link" use:blurOnClick use:trackLinkClick={{ id, title, url }}>
  <span class="title">{title}</span>
</a>

<style>@charset "UTF-8";
.Link {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  outline: 0;
  border: 0;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  padding: 20px 50px 20px 25px;
  background-color: var(--color-background, #fff);
}
.Link::-moz-focus-inner {
  border: 0;
}
.Link:focus {
  outline: none;
}
.Link::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.Link:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.Link > * {
  position: relative;
}

.title {
  position: relative;
  font-weight: var(--font-weight-medium, 500);
}</style>
